module.exports = __webpack_public_path__ + "91c82be8ce8ec6b298a308d33f81fcfd.svg";